import factoryLogger from '../../logger/index.js'
import TrackingServicesFactory from '../../tracking/Services/factory.js'
import {GigyaSignatureEntity} from '../Entities/GigyaSignatureEntity.js'
import AuthenticationRepositoriesFactory from '../Repositories/factory.js'
import AuthenticationServicesFactory from '../Services/factory.js'
import AuthenticationValueObjectsFactory from '../ValueObjects/factory.js'
import GetAuthenticationTrackingUseCase from './GetAuthenticationTrackingUseCase.js'
import GetScreensetUseCase from './GetScreensetUseCase.js'
import LoginAuthenticationUseCase from './LoginAuthenticationUseCase.js'
import NotifyAutenticationPasswordUseCase from './NotifyAutenticationPasswordUseCase.js'
import VerifyAuthenticationUseCase from './VerifyAuthenticationUseCase.js'

export default class AuthenticationUseCasesFactory {
  static getAuthenticationTrackingUseCase = ({config}) =>
    new GetAuthenticationTrackingUseCase({
      service: AuthenticationServicesFactory.getAuthenticationTrackingService({
        config
      }),
      gigyaEventFactory: AuthenticationValueObjectsFactory.gigyaEventAuthenticationValueObject
    })

  static loginAuthenticationUseCase = ({config}) =>
    new LoginAuthenticationUseCase({
      config,
      loginAuthenticationService: AuthenticationServicesFactory.loginAuthenticationService({config}),
      gigyaSignatureEntity: GigyaSignatureEntity.createFromGigyaApiResponse,
      loginInfoAuthenticationValueObject: AuthenticationValueObjectsFactory.loginInfoAuthenticationValueObject,
      fallbackRepository: AuthenticationRepositoriesFactory.sessionStorageAuthenticationRepository({config}),
      defaultRepository: AuthenticationRepositoriesFactory.configRepository({
        config
      }),
      getIdentifyTrackingDataService: TrackingServicesFactory.getIdentifyTrackingDataService({config})
    })

  static notifyAutenticationPasswordUseCase = ({config}) =>
    new NotifyAutenticationPasswordUseCase({
      service: AuthenticationServicesFactory.notifyAuthenticationPasswordService({
        config
      }),
      gigyaEventFactory: AuthenticationValueObjectsFactory.gigyaEventAuthenticationValueObject
    })

  static getScreensetUseCase = ({config}) =>
    new GetScreensetUseCase({
      service: AuthenticationServicesFactory.getScreensetService({config}),
      screensetFactory: AuthenticationValueObjectsFactory.screensetValueObject
    })

  static verifyAuthenticationUseCase = ({config}) => {
    return new VerifyAuthenticationUseCase({
      config,
      log: factoryLogger({prefix: 'VerifyAuthenticationUseCase'}),
      service: AuthenticationServicesFactory.verifyAuthenticationService({
        config
      })
    })
  }
}
